import styled from "styled-components"

import { maxWidth } from "utils"

import GenericModal from "components/modal"

export const SearchModal = styled(GenericModal)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  color: ${(props) => props.theme.colors.text.alternate};
  background: #222;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: solid 1px rgba(187, 187, 187, 0.15);
  padding: 1.5rem 4rem 1.5rem 6rem;
  margin-bottom: 6rem;

  ${maxWidth.tablet`
    padding: 1.5rem 2rem;
    margin-bottom: 3rem;
  `}

  /* IE 11 */
  button svg {
    max-width: 1.3rem;
  }
`

export const Logo = styled.div`
  font-size: 2.9rem;
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;

  ::after {
    content: "Mindbodygreen";
  }

  ${maxWidth.tablet`
    ::after {
      content: 'Mbg'
    }
  `}
`

export const InputWrap = styled.form`
  display: block;
  margin: 0 8rem;

  ${maxWidth.tablet`
    margin: 0 2rem;
  `}

  /* IE 11 */
  button[type="submit"] svg {
    max-height: 1.5rem;
  }
`

export const InputFlex = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.5rem;

  > * {
    flex-shrink: 0;
  }

  /* IE 11 */
  > svg {
    max-width: 3.4rem;
  }
`

export const Label = styled.label`
  text-transform: uppercase;
  font-size: 1.2rem;
  letter-spacing: 0.5px;
  line-height: 1.17;
  font-weight: 500;
  color: ${(props) => props.theme.colors.text.alternate};
`

export const Input = styled.input`
  &[type="text"] {
    outline: 0;
    font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 3.5rem;
    line-height: 1.3;
    border: none;
    flex: 1 0 auto;
    width: 0;
    background: transparent;
    color: ${(props) => props.theme.colors.text.alternate};
    margin: 0 2rem;
    border-radius: 0;
    border-bottom: 0.2rem solid ${(props) => props.theme.colors.text.alternate};

    ${maxWidth.mobile`
      font-size: 2.6rem;
    `};
    ${maxWidth.tablet`
      font-size: 3rem;
    `};
  }
`

export const Category = styled.h2`
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 1.2rem;
  padding: 1rem 10rem;
  text-transform: uppercase;
  margin-top: 3rem;
  font-weight: 500;

  ${maxWidth.tablet`
    padding: 1rem 2rem;
  `}
`

export const Item = styled.h3`
  padding: 1.6rem 10rem;
  font-size: 2.2rem;
  font-weight: 500;
  opacity: 0.8;

  :hover {
    background: rgba(0, 0, 0, 0.05);

    > a {
      transform: translate(2%, 0);
    }
  }

  > a {
    transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  }

  a {
    display: block;
    text-decoration: none;
    color: ${(props) => props.theme.colors.text.alternate};
  }

  ${maxWidth.tablet`
    font-size: 1.5rem;
    padding: 1.6rem 2rem;
    box-shadow: inset 0 -1px 0 0 rgba(255,255,255,.2);
  `}

  ${maxWidth.mobile`
    font-size: 1.2rem;
  `}
`
